import { render, staticRenderFns } from "./modal-configuracoes-termo-compra.vue?vue&type=template&id=f075f468&scoped=true"
import script from "./modal-configuracoes-termo-compra.vue?vue&type=script&lang=js"
export * from "./modal-configuracoes-termo-compra.vue?vue&type=script&lang=js"
import style0 from "./modal-configuracoes-termo-compra.vue?vue&type=style&index=0&id=f075f468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f075f468",
  null
  
)

export default component.exports